<template>
  <div ref="caseShow" v-show="listData.length > 0" class="case-show-container">
    <div ref="caseShowContent" class="case-show-content max-width">
      <div class="title-slot">
        <slot name="title"></slot>
      </div>
      <div class="list-container" ref="caseShowContent">
        <div v-for="item in listData" :key="item.id" class="item" @click="$router.push({ path:'/detail', query: { id: item.id }})">
          <div class="case-img-container">
            <img :src="item.src | imgFilter" />
          </div>
          <div class="sub-title">{{ item.subtitle }}</div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { getAllNewsOrCase } from "@/api";
export default {
  props: {
    type: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      listData: []
    };
  },
  methods: {
    async init() {
      const res = await getAllNewsOrCase({
        type: this.type,
        case_news: 0
      }).catch(e => false);
      if (!res || res.code != 200) return;
      this.listData = res.data.map(item => {
        return {
          id: item.news_id,
          src: item.cover,
          title: (item.en_title || " ").toUpperCase(),
          subtitle: item.title
        };
      });
      this.resize();
    },
    resize() {
      // this.imgH = (this.$refs.caseShowContent.clientWidth - 12) / 2;
      // console.log(this.$refs.caseShowContent.clientWidth)
    },
    /**
     * 页面滑动到当前
     */
    scroll() {
      const dom = this.$refs.caseShow;
      dom &&
        dom.scrollIntoView({
          behavior: "smooth",
          block: "start"
        });
    }
  },
  created() {
    this.init();
  },
  mounted() {

  }
};
</script>


<style lang="scss" scoped>
.case-show-container {
  padding-top: 20px;
  width: 100%;
  .case-show-content {
    max-width: 1366px;
    margin: 0 auto;
    .title-slot{
      padding-top: 100px;
    }
    .list-container {
      cursor: pointer;
      margin-top: 119px;
      display: flex;
      flex-wrap: wrap;
      .item {
        width: calc(50% - 40px);
        margin-right: 40px;
        margin-bottom: 12px;
        margin-bottom: 5vw;
        &:nth-child(2n) {
          margin-right: 0;
        }
        .case-img-container {
          overflow: hidden;
          width: 100%;
          overflow: hidden;
          img {
            width: 100%;
            transition: all 1s;
            &:hover {
              transform: scale(1.1);
            }
          }
        }
        .title {
          color: #30659b;
          font-size: 16px;
          margin-top: 22px;
        }
        .sub-title {
          color: #333;
          font-size: 18px;
          margin-top: 11px;
          text-align: center;
        }
        .detail-btn {
          width: 6.5vw;
          height: 2.7vw;
          background-image: url("~@/assets/case/btn_arrow_n@2x.png");
          background-size: 100% 100%;
          cursor: pointer;
          margin-top: 44px;
          &:hover {
            background-image: url("~@/assets/case/btn_arrow_h@2x.png");
          }
        }
      }
    }
  }
}
</style>
